import Breadcrumb from "components/Navigation/Breadcrumb";
import TitleMenu from "components/Navigation/TitleMenu";
import SatisfactionPopup from "components/popups/SatisfactionPopup";
import Input, { InputType } from "components/shared/inputs/input";
import { SvgCommandDownload, SvgDocumentDownload, SvgExcelDownload } from "components/svg";
import { getSynthesisPages } from "configApp";
import { usePopup } from "providers/PopupProvider";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { useLazyGetDocumentsQuery, useLazyGetUserInfoQuery, useLazyGetVATQuery } from "store/api";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { APP_URL, getAppUrl } from "utils/defines";
import { getEnvCode, useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";
import QuoteSection from "./StepQuote/QuoteSection";
import { setSatisfactionGoBack } from "store/commonSlice";
import { useProject } from "utils/hooks/useProject";
import numeral from "numeral";
import { convertToSelect } from "utils";
import { CommentPopup } from "components/popups/CommentPopup";
import { useForm } from "react-hook-form";
import { addNotification, hideLoader, showLoader } from "store/componentsSlice";
import NavigationButtons from "components/NavigationButtons";
import { saveAs } from "file-saver"
import { generateKey } from "utils/helpers";
import { isIOS, isAndroid } from 'react-device-detect'

const ProjectStepSynthesis: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { network, isThermor, isPacific } = useSalesNetwork();
    const navigate = useNavigate();
    const { openPopup, closeLastPopup } = usePopup();
    const projectStore = useAppSelector((state) => state.project);
    const [luaService_getDocuments] = useLazyGetDocumentsQuery();
    // const { data: documents } = useGetDocumentsQuery(
    //     { env: getEnvCode(), productCode: projectStore.project.selectedProduct?.product.code_env || "2638" }, { skip: !network });
    const [checkedPages, setCheckedPages] = useState<any>({});
    const [satisfactionModalOpened, setSatisfactionModalOpened] = useState(false);
    const [toogleSaveModal, setToogleSaveModal] = useState(false);
    const [generateInProgress, setGenerateInProgress] = useState(false);
    const [luaService_getVAT] = useLazyGetVATQuery();

    const { generateCsv, generateXlsx, quoteGetLineTotal, quoteGetTotal, generateSynthesis: generateSynthesisAction,
        saveStore, computeTotal, setVat, setComment, setQuoteTotal, setQuoteTotalHT, setQuoteLines } = useProject();
    const [userService_get] = useLazyGetUserInfoQuery();

    const [documents, setDocuments] = useState<any>(null);
    const [data, setData] = useState<
        {
            vat: any[];
            selectedVAT: string;
            lines: any[];
            comment: string | undefined | null;
            commentTemp: string | undefined | null;
            commentModalOpen: boolean;
        }
    >({
        vat: [],
        selectedVAT: '0',
        lines: [],
        comment: null,
        commentTemp: null,
        commentModalOpen: false,
    });

    const { control, reset } = useForm<any>({
        defaultValues: useMemo(() => {
            return data
        }, [data])
    });

    // console.log("From: ", getValues())
    // console.log("Data: ", data)

    useEffect(() => {
        reset(data)
    }, [data, reset])

    useEffect(() => {
        async function fetchData() {
            //quote
            const vat = await luaService_getVAT({ env: network?.code }).unwrap();
            const userInfos = await userService_get().unwrap();

            const _selectedVat = projectStore.project.quote?.vat
                ? projectStore.project.quote.vat
                : vat?.length > 0 // NOSONAR
                    ? vat[0].code
                    : '0';

            const accessories = (projectStore.project.accessories?.recommendedAccessories || [])
                .slice()
                .concat(projectStore.project.accessories?.otherAccessories?.slice().filter((acc: any) => acc._selected))
                .concat((projectStore.project.quote?.otherlines || []).slice())
                .map((acc: any) => {
                    const _acc = { ...acc, _type: 'accessories' };
                    return sanitizeItem(_acc);
                })

            const _product = { ...projectStore.project.selectedProduct.product, _type: 'generator', _selected: true }
            //projectStore.project.selectedProduct.product._type = 'generator'
            //projectStore.project.selectedProduct.product._selected = true
            //sanitizeItem(projectStore.project.selectedProduct.product)
            sanitizeItem(_product)

            //setQuoteLines([projectStore.project.selectedProduct.product, ...accessories])
            setQuoteLines([_product, ...accessories])

            //debugger

            setData((prev) => ({
                ...prev,
                vat: convertToSelect(vat),
                selectedVAT: _selectedVat,
                comment: projectStore.project.quote?.comment ? projectStore.project.quote.comment : userInfos?.comment,
                lines: [_product, ...accessories]
            }));

            //setValue("selectedVAT", _selectedVat)




            //satisfactionModal
            const lastDemand = localStorage.getItem('satisfactionLastDemand')
            if (lastDemand) {
                if (lastDemand !== 'filled') {
                    const nextTry = new Date(lastDemand)
                    const now = new Date()
                    nextTry.setMonth(nextTry.getMonth() + 1)
                    if (now >= nextTry) setSatisfactionModalOpened(true);
                }
            } else {
                setSatisfactionModalOpened(true);
            }

            const _checkedPages: any = {}
            const _synthesisPages = getSynthesisPages(network?._parameters.SYNTH_PARAMETER)
            if (_synthesisPages) {
                _synthesisPages.forEach((page) => {
                    _checkedPages['page_' + page.id] = true
                })
            }

            const _documents = await luaService_getDocuments({ env: getEnvCode(), productId: _product.id }).unwrap();
            setDocuments(_documents);

            setCheckedPages(_checkedPages);
        }

        fetchData();
    }, [])

    useEffect(() => {
        if (satisfactionModalOpened) {
            openPopup(
                <SatisfactionPopup
                    closePopup={closeLastPopup}
                    yesClick={satisfactionModalYes}
                    noClick={satisfactionModalNo}
                ></SatisfactionPopup>
            )
        }
    }, [satisfactionModalOpened]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (data) reset()
    }, [data, reset])

    const sanitizeItem = (item: any) => {
        item.price = parseFloat(item.price)
        if (item.eco != null) {
            item.eco = parseFloat(item.eco)
        }

        if (item._qty == null) {
            item._qty = item._selected ? 1 : 0
        } else item._qty = parseInt(item._qty)

        if (item._discount == null) item._discount = 0
        else item._discount = parseFloat(item._discount)

        return item
    }

    const submit = useCallback(() => {
        const total =
            computeTotal(projectStore.project.quote.otherlines, data.selectedVAT as any, true, true) +
            computeTotal(projectStore.project.quote.lines, data.selectedVAT as any, false, true)
        const totalHT =
            computeTotal(projectStore.project.quote.otherlines, 0) +
            computeTotal(projectStore.project.quote.lines, 0)

        setComment(data.comment as any)
        setQuoteTotal(total)
        setQuoteTotalHT(totalHT)
        setVat(data.selectedVAT)
        saveStore()

        return Promise.resolve()
    }, [computeTotal, data.comment, data.selectedVAT, projectStore.project.quote.lines, projectStore.project.quote.otherlines,
        saveStore, setVat, setQuoteTotal, setQuoteTotalHT, setComment
    ])

    const handleSaveModalResponse = useCallback((header: any) => {
        if (generateInProgress) {
            setGenerateInProgress(false);
            if (header) {
                setTimeout(() => {
                    dispatch(addNotification({
                        type: "success",
                        message: t('SYNTHESIS_GEN_IN_PROGRESS'),
                    }))

                    dispatch(showLoader())
                    //, { hideProgressBar: true })
                }, 500)



                generateSynthesisAction(checkedPages, header)
                    .then((res: any) => {

                        let name = ""
                        if (isThermor) name = 'simulhome-synthesis.pdf'
                        else if (isPacific) name = 'project-synthesis.pdf'
                        else name = 'projipac-synthesis.pdf'

                        dispatch(hideLoader())

                        //saveAs(res.data, name)
                        if (isIOS || isAndroid) {
                            // Open in new tab -> pb with adblock
                            const blob = new Blob([res.data], { type: 'application/pdf' })
                            // window.URL.createObjectURL(blob)
                            saveAs(blob, name)
                        } else {
                            saveAs(res.data, name)
                        }
                    })
                    .catch((_: any) => {
                        dispatch(hideLoader())
                        // An error message is already catch globally
                        // toast.error(_T('FRONT_GENERATE_SYNTHESIS_ERROR'))
                    })
            }
        }
    }, [generateInProgress, generateSynthesisAction, setGenerateInProgress, checkedPages, dispatch, isPacific, isThermor, t])

    const generateSynthesis = useCallback(() => {
        submit();
        setToogleSaveModal(true);
        setGenerateInProgress(true);
    }, [submit])

    // const handlePageSelection = (e: any) => {
    //     const item = e.target.name;
    //     const isChecked = e.target.checked;

    //     const _checkedPages = { ...checkedPages };
    //     _checkedPages[item] = isChecked;

    //     setCheckedPages(_checkedPages);
    // }

    const handlePageSelectionChecked = (name: string, checked: boolean) => {
        const item = name;
        const isChecked = checked;

        const _checkedPages = { ...checkedPages };
        _checkedPages[item] = isChecked;

        setCheckedPages(_checkedPages);
    }

    const satisfactionModalYes = () => {
        dispatch(setSatisfactionGoBack(true));
        //history.push(`/${UIStore.env}/satisfaction`); // NOSONAR
        closeLastPopup();
        navigate(getAppUrl(APP_URL.Satisfaction));
    }

    const satisfactionModalNo = () => {
        closeLastPopup();
        setSatisfactionModalOpened(false);
        localStorage.setItem('satisfactionLastDemand', new Date().toString())
    }

    const synthesisPages = getSynthesisPages(network?._parameters.SYNTH_PARAMETER)






    const getTotal = useCallback((items: any, applyVAT: boolean = false) => {
        let itemsCopy = []

        if (!Array.isArray(items)) {
            itemsCopy = [items]
        } else {
            itemsCopy = items
        }

        // console.log(items)

        let total = 0
        itemsCopy.forEach((item) => {
            if (!item._selected) return;
            total += quoteGetLineTotal(item);
        })

        return quoteGetTotal(total, applyVAT, applyVAT ? parseFloat(data.selectedVAT) : 0).round(2)
    }, [data, quoteGetTotal, quoteGetLineTotal]);

    const getVatTotal = useCallback((items: any) => {
        const totalWithVat = getTotal(items, true);
        const totalWithOutVat = getTotal(items, false);

        return totalWithVat - totalWithOutVat;
    }, [getTotal])

    const updateQuote = useCallback((lines: any) => {
        setData((prev) => ({
            ...prev, lines: lines
        }))

        setQuoteLines([...lines])
    }, [setQuoteLines])

    const addProduct = useCallback((_: any) => {
        const _lines = [...data.lines]
        _lines.push({
            _type: 'accessories',
            _custom: 'true',
            _qty: 1,
            _discount: 0,
            _selected: true,
            code_env: '',
            reference: '',
            price: 0,
            eco: 0,
        })
        updateQuote(_lines)
    }, [data.lines, updateQuote]);



    const deleteProduct = useCallback((_: any, index: number) => {
        const _lines = [...data.lines]
        const _line = { ..._lines[index] }
        _line._selected = false
        _lines[index] = _line

        updateQuote(_lines)
    }, [data.lines, updateQuote]);



    const onChange = useCallback((name: string, value: any, index: number, min?: number, max?: number) => {

        let _value = value;
        if (min != null && (_value < min || !_value)) _value = min
        if (max != null && _value > max) _value = max

        const _lines: any = [...data.lines]
        const _line = { ..._lines[index] }
        _line[name] = _value
        _lines[index] = _line

        if (name === '_qty' && _value > 0 && _line._recommended) _line._selected = true

        updateQuote(_lines)
    }, [data.lines, updateQuote]);



    const openCommentPopup = useCallback(() => {
        //setData({ ...data, comment: data.comment ? "" : "aaaaaaaaaaa" })

        openPopup(
            <CommentPopup
                comment={data.comment as string}
                maxLength={600}
                onCommentChange={(value: string) => {
                    setData((prev) => ({
                        ...prev, comment: value
                    }));
                    closeLastPopup();
                }}
                closePopup={closeLastPopup}
            ></CommentPopup>
        )
    }, [data, openPopup, closeLastPopup])
    //console.log(data.vat)

    const onChangeVAT = useCallback((e: any) => {
        //const { value } = e.target
        //setValue("selectedVAT", e);
        setData((prev) => ({
            ...prev,
            selectedVAT: e,
        }))
    }, [])

    const synthesisPagesContent = (
        <>
            <group data-gap="20">
                <group><text data-text-size="22" data-weight="600">{t("MY_SYNTHESIS")}</text></group>
                <group><text data-wrap="wrap" data-weight="600">{t("WHAT_DOC_TO_JOIN")}</text></group>
            </group>

            {synthesisPages.map((page: any) => {
                const pageName = 'page_' + page.id
                return (
                    <group key={generateKey()}>
                        <Input
                            name={pageName}
                            type={InputType.Checkbox}
                            label={t(page.label)}
                            checked={checkedPages[pageName]} //NOSONAR
                            //onChange={handlePageSelection} // NOSONAR
                            onCustomChange={handlePageSelectionChecked}
                        />
                    </group>
                )
            })}

            <group data-length="forcefit" data-fit="1" data-justify="start" >
                <space data-height="40"></space>
                <div className="button large secondary" onClick={generateSynthesis}>
                    <icon data-svg-size="20" data-svg-color="white"><SvgCommandDownload /></icon>
                    <text data-width="auto">{t("GENERATE_SYNTHESIS")}</text>
                </div>

                <NavigationButtons
                    toogleSaveModal={toogleSaveModal}
                    generateSynthesis={true}
                    onClose={() => { setToogleSaveModal(false) }}
                    handleSaveModalResponse={handleSaveModalResponse}
                    handleBeforeSubmit={submit}
                />
            </group>
        </>
    );

    const documentsContent = (
        <group data-direction="column" data-space-top="20" data-gap="20">
            {documents?.map((doc: any, index: number) => (
                <a
                    key={'doc' + index}
                    href={doc.link}
                    target="_blank"
                    rel="noopener noreferrer"

                >
                    <group
                        //className="button large"
                        data-space-left="0"
                        data-wrap="no"
                        data-gap="10"
                    >

                        <icon data-svg-size="30" data-svg-color="secondary"><SvgDocumentDownload /> </icon>

                        <group data-justify="start" data-align="center" >
                            <text data-wrap="wrap">{doc.label}</text>
                        </group>
                    </group>
                </a>
            ))}
        </group>
    );

    const topNavigationContent = (
        <NavigationButtons
            handleSubmit={submit}
            hideNext={true} hidePrev={true} rightAlign={true} topSpace={0} horisontalSpace={0}
            accent={true} showIcon={false}
            showNew={true}
        />
    );

    return (
        <>
            <TitleMenu title={projectStore.project.id ? projectStore.project.header.projectRef : t("MMENU_NEW_SIMULATION")} />
            <Breadcrumb
            //handleSubmit={submit}
            />

            <group data-direction="column" data-align="center" data-height="autofit">
                <group data-space="20" data-gap="20" data-max-length='1200' data-direction="column">

                    <group data-align="center" data-space-vertical="20">
                        <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20">
                            <group data-length="autofit"
                                {...(isThermor ? {} : { "data-color": "main" })}
                            >
                                <text data-text-size="xx-large">{t("MY_DOCUMENTS")}</text>
                            </group>
                            <group data-adaptive="desktop">
                                {topNavigationContent}
                            </group>
                        </group>
                        <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20" data-adaptive="mobile">
                            <group>
                                {topNavigationContent}
                            </group>
                        </group>

                        <group data-align="center"
                            {...(isThermor ? {} : { "data-radius": "extra-special" })}
                            //data-height="100"
                            {...(isThermor ? { "data-border-color": "main-color-custom-border" } : { "data-color": "main" })}
                            data-border="inheret"
                            data-direction="column"
                            data-background="white"

                        >
                            <group>
                                <group
                                    data-fit="3"
                                    data-height="auto"
                                    data-color="black"
                                    data-space="30"
                                    data-space-horizontal="40"
                                    data-gap="5"
                                    data-adaptive="desktop-1000"
                                >

                                    {synthesisPagesContent}
                                </group>

                                {isThermor && <group
                                    data-length="1"
                                    // data-justify="end"
                                    // data-align="start"
                                    data-color="black"
                                    data-adaptive="desktop-1000"
                                    data-space-vertical="30"
                                >
                                    <group data-border-color="main-color-custom-border"></group>
                                </group>}

                                <group
                                    data-fit="2"
                                    data-height="auto"
                                    data-color="black"
                                    data-radius="extra-special"
                                    data-background="main-color-custom-lighter"
                                    data-space="30"
                                    data-space-horizontal="40"
                                    data-radius-top-left="0"
                                    data-radius-bottom-left="0"
                                    data-justify="start"
                                    data-align="start"
                                    data-adaptive="desktop-1000"
                                >
                                    <group data-space-horizontal="20">
                                        <group>
                                            <text data-text-size="22" data-weight="600" data-wrap="wrap">{t("DOWNLOADABLE_DOCUMENT")}</text>
                                            <text data-text-size="22" data-color="main" data-wrap="wrap" data-weight="600">{projectStore.project.selectedProduct?.product.reference}</text>
                                        </group>


                                        {documentsContent}
                                    </group>
                                </group>



                                <group
                                    data-fit="1"
                                    data-length="auto"
                                    data-height="auto"
                                    data-color="black"
                                    data-space="30"
                                    data-gap="5"
                                    data-adaptive="mobile-1000"
                                >

                                    {synthesisPagesContent}
                                </group>



                                <group
                                    data-fit="1"
                                    data-length="auto"
                                    data-height="auto"
                                    data-color="black"
                                    data-radius="extra-special"
                                    data-space="30"
                                    data-space-top="0"
                                    data-radius-top-left="0"
                                    data-radius-bottom-left="0"
                                    data-justify="start"
                                    data-align="start"
                                    data-gap="20"
                                    data-adaptive="mobile-1000"
                                >
                                    <separator data-horizontal="" />
                                    <group>
                                        <group>
                                            <text data-text-size="22" data-weight="600" data-wrap="wrap">{t("DOWNLOADABLE_DOCUMENT")}</text>
                                        </group>
                                        <group>
                                            <text data-text-size="22" data-color="main" data-wrap="wrap" data-weight="600">{projectStore.project.selectedProduct?.product.reference}</text>
                                        </group>


                                        {documentsContent}
                                    </group>
                                </group>
                            </group>
                        </group>
                    </group>


                    <group data-align="center" data-space-vertical="20">
                        <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20" >
                            <group data-length="autofit"
                                {...(isThermor ? {} : { "data-color": "main" })}
                            >
                                <text data-text-size="xx-large">{t("MY_QUOTE")}</text>
                            </group>
                        </group>

                        <QuoteSection
                            name={t("GENERATOR")}
                            filter="generator"
                            items={data.lines}
                            showEco={true}
                            getTotal={getTotal}
                            onChange={onChange}
                            control={control}
                        />

                        <QuoteSection
                            name={t("DOCUMENT_ACC")}
                            filter="accessories"
                            items={data.lines}
                            getTotal={getTotal}
                            onChange={onChange}
                            showEco={true}
                            addProduct={addProduct}
                            deleteProduct={deleteProduct}
                            comment={data.comment}
                            openCommentPopup={openCommentPopup}
                            control={control}
                        />


                        <group data-align="center" data-space-vertical="30">
                            <group data-space="30"
                                {...(isThermor ? { "data-background": "black", "data-color": "white" } : { "data-background": "main-color-custom-lighter" })}
                                data-border="inheret"
                                data-border-color="main-color-custom-lighter"
                                {...(isThermor ? {} : { "data-radius": "extra-special" })}
                                data-contain="" >
                                {!network?._parameters.hidePrice && <group data-gap="20" data-wrap="no" >
                                    <group data-fit="1" data-gap="20" data-length="forcefit" data-adaptive="desktop-1000"></group>
                                    <group data-fit="1" data-gap="20" data-length="forcefit" data-align="center" data-space-horizontal="40">
                                        <group data-fit="2" data-gap="20" data-align="center">
                                            <text data-text-size="large" data-length="autofit" data-weight="300">{t("CHOOSE_VAT")}</text>
                                            <group data-length="autofit" data-min-length="50">
                                                <Input
                                                    size="large"
                                                    name="selectedVAT"
                                                    control={control}
                                                    dataLength="100"
                                                    onChange={(e) => {
                                                        onChangeVAT(e)
                                                        //e.stopPropagation()
                                                    }}
                                                    type={InputType.Select}
                                                    options={data.vat}
                                                    width={100}

                                                />
                                            </group>
                                        </group>
                                        <group data-fit="1" data-width="auto" data-position="right" >
                                            <text data-text-size="large" data-length="autofit" data-text-align="right" data-weight="600">{numeral(getVatTotal(data.lines)).format('0,0.00')} {network?._parameters.currency}</text>
                                        </group>
                                    </group>
                                </group>}

                                {!network?._parameters.hidePrice && <group data-gap="20" data-wrap="no" >
                                    <group data-length="forcefit" data-fit="1" data-gap="20" data-adaptive="desktop-1000"></group>
                                    <group data-length="forcefit" data-fit="1" data-gap="20" data-align="center" data-space-horizontal="40">
                                        <group data-length="" data-fit="2" data-gap="20">
                                            <text data-text-size="large" data-length="autofit" data-weight="300">{t('TOTAL_TTC', { currency: network?._parameters.currency })}</text>
                                        </group>
                                        <group data-length="" data-fit="1" data-width="auto" data-position="right" data-max-length="160">
                                            <text data-text-size="22" data-length="autofit" data-text-align="right" data-weight="600">{numeral(getTotal(data.lines, true)).format('0,0.00')} {network?._parameters.currency}</text>
                                        </group>
                                    </group>
                                </group>}
                            </group>
                        </group>

                        <group data-gap="20">
                            <group data-length="forcefit" data-fit="1" data-gap="20" data-justify="end">
                                <div className="button large secondary outline" data-length="forcefit" onClick={generateCsv}>
                                    {!isThermor && <icon data-svg-size="20" data-svg-color="secondary"><SvgCommandDownload /></icon>}
                                    <text data-width="auto">{t("SF_EXPORT")}</text>
                                </div>
                                <div className="button large secondary outline" data-length="forcefit" onClick={() => generateXlsx(parseFloat(data.selectedVAT))}>
                                    {!isThermor && <icon data-svg-size="20" data-svg-color="secondary"><SvgExcelDownload /></icon>}
                                    <text data-width="auto">{t("XLS_EXPORT")}</text>
                                </div>
                            </group>
                        </group>

                    </group>

                </group>
            </group>
        </>
    )
}

export default ProjectStepSynthesis;